import { createAction } from '@reduxjs/toolkit'

import { BaseCustomerWalletState } from './types'

export const resetCustomerCardAction = createAction<void>('customer-wallet/reset-customer-card')
export const setCustomerCardAction = createAction<BaseCustomerWalletState>('customer-wallet/set-customer-card')
